var path = 'components/settings/tooltips/tvOrganizations.html';
var html = "<div class=tooltip-list> <div ng-repeat=\"item in tv.overrides\"> <span access=\"\" ng-bind=\"item.target.entityName || item.target\"></span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;